import * as React from 'react';
import { Alert } from 'omakase';
import { GiftCard } from 'state/giftCard';
import { core } from '@tock/coretypes';
import AddGiftCardForm from 'components/gift-card/AddGiftCardForm';
import Anchor from 'components/Anchor';
import BaseComponent from '@tock/shared/components/BaseComponent';
import RemoveGiftCard from 'components/gift-card/RemoveGiftCard';
import _ from 'lodash';

interface Props {
  giftCardProvider: core.Business.GiftCardProvider;
  giftCardPinType: core.Business.GiftCardPinType;
  giftCardRequestInProgress: boolean;
  giftCards: GiftCard[];
  onAddGiftCard(giftCard: core.GiftCard, amountCents: number): void;
  onRemoveGiftCard(cardNumber: string): void;
  totalPrice: number;
}

interface State {
  giftCardTouched: boolean;
  showAddCardForm: boolean;
}

class GiftCardWrapper extends BaseComponent<Props, State> {
  state = {
    showAddCardForm: false,
    giftCardTouched: false,
  };

  componentDidUpdate(prevProps: Props) {
    const { giftCards } = this.props;

    if (giftCards.length > prevProps.giftCards.length) {
      this.setState({
        showAddCardForm: false,
      });
    }
  }

  handleGiftCardTouched() {
    this.setState({
      giftCardTouched: true,
    });
  }

  showAddCardForm(event: React.MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
    this.setState({
      showAddCardForm: true,
    });
  }

  sanitizeGiftCard(cardNumber: string): string {
    return _.replace(cardNumber, ' ', '');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onAddGiftCard(formValues: any) {
    const { giftCardProvider, onAddGiftCard } = this.props;
    onAddGiftCard(
      {
        externalIdentifier: this.sanitizeGiftCard(formValues.cardNumber),
        giftCardProvider,
        externalPin: formValues.cardPin,
      },
      formValues.amountCents
    );
  }

  render() {
    const { giftCards, giftCardPinType, onRemoveGiftCard } = this.props;

    return (
      <div className="GiftCard-wrapperHeader">
        {giftCards.length > 0 && (
          <div className="GiftCard-appliedCards">
            {giftCards.map((giftCardDetails) => (
              <RemoveGiftCard
                key={giftCardDetails.number}
                onRemove={onRemoveGiftCard}
                giftCardDetails={giftCardDetails}
              />
            ))}
          </div>
        )}

        {(giftCards.length === 0 || this.state.showAddCardForm) && (
          <div className="GiftCard-formWrapper">
            <AddGiftCardForm
              giftCardRequestInProgress={this.props.giftCardRequestInProgress}
              onGiftCardChanged={this.handleGiftCardTouched}
              onSubmit={this.onAddGiftCard}
              requirePin={giftCardPinType === 'REQUIRED'}
            />
          </div>
        )}

        {giftCards.length > 0 && !this.state.showAddCardForm && this.props.totalPrice > 0 && (
          <Anchor href="#" className="GiftCard-addAnother" onClick={this.showAddCardForm}>
            Add Another Gift Card
          </Anchor>
        )}

        {this.state.giftCardTouched && (
          <div className="GiftCard-notice">
            <Alert>
              If a gift card is applied to a purchase, you can no longer sell or give your
              reservation using Tock's transfer feature.
            </Alert>
          </div>
        )}
      </div>
    );
  }
}

export default GiftCardWrapper;
